import * as React from 'react';
import { FpjsProvider, FingerprintJSPro } from '@fingerprintjs/fingerprintjs-pro-react';
import { useExperiment } from '@contexts/experiment/useExperiment';
import { universalLoginExperiment } from '@experiments/universalLogin';

export function WithFingerprint<TProps>(Component: React.FC<TProps>): React.FC<React.PropsWithRef<TProps>> {
    const MemoizedComponent = React.memo<React.FC<TProps>>(Component);

    const ComponentWithFingerPrint: React.FC<React.PropsWithRef<TProps>> = props => {
        const experiments = useExperiment(universalLoginExperiment);
        return experiments.USE_DEVICE_INTELLIGENCE || experiments.USE_DEVICE_INTELLIGENCE_FINGERPRINT_B2C ? (
            <FpjsProvider
                loadOptions={{
                    apiKey: 'WVJdBPTvyuOHguQeXkYM',
                    endpoint: 'https://fpcom.agoda.com',
                    scriptUrlPattern: 'https://fpcom.agoda.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js',
                }}
            >
                <MemoizedComponent {...props} />
            </FpjsProvider>
        ) : (
            <MemoizedComponent {...props} />
        );
    };

    ComponentWithFingerPrint.displayName = `${Component.displayName || 'Component'}WithFingerprint`;

    return ComponentWithFingerPrint;
}
